import { Component, OnInit, inject } from '@angular/core';
import { FormGroup, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { LenderName } from '@shared/models';
import { ModalStateService } from '@shared/services';

@Component({
  selector: 'app-lender-picker',
  styleUrls: ['lender-picker.component.scss'],
  templateUrl: 'lender-picker.component.html',
  imports: [ReactiveFormsModule],
})
export class LenderPickerComponent implements OnInit {
  private readonly modalState = inject(ModalStateService, { optional: true });

  public lenderNames: LenderName[] = [];
  public lendersForm = new FormGroup({
    lenderName: new UntypedFormControl(null),
  });
  public errorMessage = '';

  public ngOnInit(): void {
    this.lenderNames = this.modalState?.options?.data ?? null;
    if (this.lenderNames?.length) {
      this.lendersForm.setValue({ lenderName: this.lenderNames[0].lenderNameId });
    }
  }

  public applyLender() {
    const formValue = this.lendersForm.getRawValue();
    if (!formValue?.lenderName) {
      this.errorMessage = 'Please select some lender';
      return;
    }

    this.modalState?.modal?.close(formValue?.lenderName);
  }

  public cancel() {
    this.modalState?.modal?.dismiss();
  }
}
